import * as React from 'react';
import { SVGProps } from 'react';

const FileIconLoadingSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 34 40" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect width={34} height={40} rx={2} />
  </svg>
);
export default FileIconLoadingSizeM;
